import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { mapProps, branch, renderNothing, compose } from 'recompose'
import CSSModules from 'helpers/CSSModulesUtil'
import Body from 'components/typography/body1/index'

import styles from './styles.scss'

const ErrorComponent = ({ error }) => (
  <div styleName='container'>
    <Body>{error}</Body>
  </div>
)

const withStyle = CSSModules(styles)
const ErrorMessage = compose(
  branch(
    ({ showError, error }) => !showError || !error,
    renderNothing
  )
)(withStyle(ErrorComponent))

ErrorComponent.propTypes = {
  error: PropTypes.string.isRequired,
  rules: PropTypes.array.isRequired
}

ErrorComponent.defaultProps = {
  error: '',
  rules: []
}

export default ErrorMessage
